import { useEffect } from 'react';

import type { UseGoodsUnitsEffectsProps } from '@app/pages/Warehouses/GoodsUnits/types';

export const useGoodsUnitsEffects = ({
  onSearchHandler,
  filtersListsHandler,
}: UseGoodsUnitsEffectsProps) => {
  useEffect(() => {
    filtersListsHandler();
  }, [filtersListsHandler]);

  useEffect(() => {
    onSearchHandler();
  }, [onSearchHandler]);
};
